import { Effect, takeLatest, select } from 'redux-saga/effects'
import getConstants from '../../../constants'

import request from 'services/Request'
import * as navigationActionTypes from 'services/Navigation/actionTypes'

import * as actionTypes from '../actionTypes'
import * as api from '../api'
import * as selectors from '../selectors'

const CONSTANTS = getConstants()

export const getStoreIdFromPath = (path: string = ''): string => {
  const match = /\/detail\/(\d+)/.exec(path) || []
  return match[1] ? match[1] : ''
}

export const isNavigationChange = (action: ActionType) =>
  action.type === navigationActionTypes.CHANGED &&
  getStoreIdFromPath(action.payload.location.pathname) !== ''

export function* getDetailsWorker(
  action: ActionType,
): Generator<unknown, any, any> {
  const storeId = getStoreIdFromPath(action.payload.location.pathname)
  const areaCode = yield select(selectors.areaCode)

  const args: api.GetStoreDetailsProps = {
    country: CONSTANTS.COUNTRY,
    storeId,
    areaCode,
  }

  yield request(actionTypes.DETAILS_REQUESTED, api.getStoreDetails, args)
}

export function* getDetailsSaga() {
  yield takeLatest(isNavigationChange, getDetailsWorker)
}

export default getDetailsSaga
